import { DOM_IDS } from '../constants.js'
import { createSubApp } from './create-sub-app.js'

const loadMobileToggleButton = () => import('../components/mobile-menu/mobile-toggle-button.vue')

let mobileToggleApp = null

export async function mountMobileToggle() {
  if (document.getElementById(DOM_IDS.MOBILE_TOGGLE_WRAPPER)) return

  const logo = document.getElementById(DOM_IDS.LOGO_CONTAINER)
  if (!logo?.parentNode) return
  // online home do not have side menu
  if (location.pathname.includes('/myhome')) return

  const wrapper = document.createElement('div')
  wrapper.id = DOM_IDS.MOBILE_TOGGLE_WRAPPER
  logo.parentNode.insertBefore(wrapper, logo)

  const { default: MobileToggleButton } = await loadMobileToggleButton()
  window.mobileToggleApp = mobileToggleApp = createSubApp({
    component: MobileToggleButton,
    container: wrapper,
    scope: 'mobile-toggle-button'
  })
}

export function unmountMobileToggle() {
  const wrapper = document.getElementById(DOM_IDS.MOBILE_TOGGLE_WRAPPER)
  if (!wrapper) return
  if (mobileToggleApp) {
    mobileToggleApp.unmount()
    mobileToggleApp = null
  }
  wrapper.remove()
}
